// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for external data
export const externalDataState = $state({});

// Function to update external data state without direct assignment
export function setExternalDataState(newState) {
  // Update all properties from the new state
  Object.keys(externalDataState).forEach(key => {
    delete externalDataState[key];
  });
  
  // Add all properties from the new state
  Object.entries(newState).forEach(([key, value]) => {
    externalDataState[key] = value;
  });
}